import {SearchClearIcon} from "../props";
import React from "react";

export const TypeAheadClearButton = ({handleClear, closeIcon, display}: SearchClearIcon) => {
  if (!display) {
    return null;
  }
  return (
    <button
      className='typeahead-search__clear-button'
      onClick={handleClear}
      aria-label='Clear search'>
      <img src={closeIcon} alt='clear search icon'/>
    </button>
  )
};
